/**
 * LoadMore Component
 * 
 * This component triggers the provided action to load more items
 * when it comes into view, using the Intersection Observer API.
 * It only activates if there are more items to load and if it's not currently loading.
 */
import { FC, memo, useEffect, useRef } from "react";

interface LoadMoreProps {
	action: () => void
	isLoading?: boolean
	hasNextPage: boolean
	trigger?: any[]
}

const LoadMore: FC<LoadMoreProps> = ({ action, isLoading, hasNextPage, trigger }) => {

	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!hasNextPage || isLoading) return;
		const node = ref.current;
		if (!node) return;
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					action();
				}
			}
		);
		observer.observe(node);	
		return () => observer.disconnect();
	}, [hasNextPage, isLoading, action, trigger]);

	if (!hasNextPage) {
		return (<></>);
	}

	return (
		<>
			{isLoading || <div ref={ref}></div>}
		</>
	)

}

export default memo(LoadMore)

